var components
try {
  components = {
    zPagingEmptyView: function () {
      return import(
        /* webpackChunkName: "uni_modules/z-paging/components/z-paging-empty-view/z-paging-empty-view" */ "@/uni_modules/z-paging/components/z-paging-empty-view/z-paging-empty-view.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var s0 = _vm.__get_style([_vm.finalPagingStyle])
  var s1 = _vm.__get_style([_vm.finalScrollViewStyle])
  var s2 = _vm.__get_style([
    _vm.scrollViewInStyle,
    {
      transform: _vm.finalRefresherTransform,
      transition: _vm.refresherTransition,
    },
  ])
  _vm.$initSSP()
  var g0 =
    _vm.useChatRecordMode &&
    _vm.$slots.chatLoading &&
    _vm.loadingStatus !== 2 &&
    _vm.realTotalData.length
  var g1 = !g0
    ? _vm.useChatRecordMode &&
      _vm.loadingStatus !== 2 &&
      _vm.realTotalData.length
    : null
  var s3 = _vm.__get_style([_vm.finalPagingContentStyle])
  var m0 = _vm._showLoadingMore("Default")
  var m1 = !m0 ? _vm._showLoadingMore("Loading") : null
  var m2 = !m0 && !m1 ? _vm._showLoadingMore("NoMore") : null
  var m3 = !m0 && !m1 && !m2 ? _vm._showLoadingMore("Fail") : null
  var m4 = !m0 && !m1 && !m2 && !m3 ? _vm._showLoadingMore("Custom") : null
  var s4 = _vm.showBackToTopClass
    ? _vm.__get_style([_vm.finalBackToTopStyle])
    : null
  var g2 =
    _vm.showBackToTopClass && !_vm.$slots.backToTop
      ? _vm.backToTopImg.length
      : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        s0: s0,
        s1: s1,
        s2: s2,
        g0: g0,
        g1: g1,
        s3: s3,
        m0: m0,
        m1: m1,
        m2: m2,
        m3: m3,
        m4: m4,
        s4: s4,
        g2: g2,
      },
    }
  )
  if (_vm.$scope.data.scopedSlotsCompiler === "augmented") {
    _vm.$setSSP("refresher", {
      refresherStatus: _vm.refresherStatus,
    })
  }
  _vm.$callSSP()
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }